<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            submit-button-text="Create"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="false"
            :can-create="false"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <div class="mb-8">
            <Btn
                content="Download Sample File"
                @click="downloadSample"
                type="button"
            />
        </div>

        <input
            type="file"
            @change="fileChanged"
            ref="file"
        />

        <div v-if="form.uploaded && form.uploaded.length">
            <table
                class="table-fixed min-w-full divide-y divide-gray-200 shadow my-4"
            >
                <thead>
                    <tr>
                        <th class="p-2 text-left">Status Code</th>
                        <th class="p-2 text-left">From</th>
                        <th class="p-2 text-left">To</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in form.uploaded">
                        <td class="p-2">{{ row.status_code }}</td>
                        <td class="p-2">{{ row.from }}</td>
                        <td class="p-2">{{ row.to }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "RedirectUploadForm",
    mixins: [crudForm],
    data() {
        return {
            sample: [
                [ 'Status Code', 'From', 'To' ],
                [ '301', '/casinos/winner-casino-review/bonuscodes/', '/casinos/'],
                [ '302', '/san-valentin/', '/cl/bonos/'],
            ],
            form: {
                uploaded: null,
            },
        };
    },
    methods: {
        fileChanged () {
            let file = this.$refs.file.files[0];

            let fr = new FileReader();
            fr.onload = () => {
                this.form.uploaded = fr.result.split('\n').filter((row, index) => {
                    let split = row.split(',');
                    // skip the header row and empty rows
                    return index > 0
                        && split.length === 3 && split[0] && split[1] && split[2];
                }).map((row) => {
                    let split = row.split(',');

                    return {
                        status_code: split[0],
                        from: split[1],
                        to: split[2],
                    };
                });
            };
            fr.readAsText(file);
        },
        downloadSample() {
            let csvBody = this.sample.map(row => row.join(',')).join('\n');

            let hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvBody);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'upload_sample.csv';
            hiddenElement.click();
        },
    },
};
</script>
